let html = `<div class="lang">
    <div class="lang__body">
        <div class="lang__logo">
            <img src="./img/logo-icon.svg" />
        </div>
        <div class="lang__title"></div>
        <div class="lang__subtitle"></div>
        <div class="lang__selector"></div>
    </div>
</div>`

export default html